import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setSideMenuSelectedItem, setToolbarTitle } from "../../../redux/actions";
import { releaseList } from "../../../network/api";
import Adapter from "./list-adapter";
import Toolbar from "../../util/list-toolbar";
import { see_more } from "../../../resources/string/strings";
import Loading from "../../util/page-loading";
import NoItemFound from "../../util/no-item-found";

class Releases extends Component {
  state = {
    pageTitle: " ریلیزهای ",
    pageTag: "releases",
    page: 0,
    pageSize: 25,
    loading: true,
    endOfList: false,
    count: 0,
    keyword: "",
    sortBy: "versionCode",
    sortType: "DESC",
    filters: [],
    isSearchTyping: false,
    list: [],
  };

  componentDidMount() {
    this.props.setSideMenuSelectedItem(this.state.pageTag);
    this.props.setToolbarTitle(this.state.pageTitle + this.getQueryString("t", "اپلیکیشن"));
    document.title = this.state.pageTitle + this.getQueryString("t", "اپلیکیشن");
    this.getFirstPage();
  }

  render() {
    return (
      <div>

        <Toolbar
          onSearchKeywordChanged={this.onSearchKeywordChanged}
          onSortByChanged={this.onSortByChanged}
          onSortTypeChanged={this.onSortTypeChanged}
          filterchanged={this.onFilterChanged}
          sortBy={[
            ['ترتیب: کد نسخه', 'versionCode'],
            ['ترتیب: نام نسخه', 'versionName'],
            ['ترتیب: تاریخ', 'date'],
          ]}
          filters={[
            {
              "title": "نسخه ریلیز",
              "id": "publicRelease",
              "field": "publicRelease",
              "query": "is",
              "type": "dropdown",
              "items": [
                {
                  "title": "---",
                  "value": null
                },
                {
                  "title": "باشد",
                  "value": true
                },
                {
                  "title": "نباشد",
                  "value": false
                }
              ]
            },
            {
              "title": "لغو شده",
              "id": "rollback",
              "field": "rollback",
              "query": "is",
              "type": "dropdown",
              "items": [
                {
                  "title": "---",
                  "value": null
                },
                {
                  "title": "باشد",
                  "value": true
                },
                {
                  "title": "نباشد",
                  "value": false
                }
              ]
            },
            {
              "title": "بزرگتر از کد نسخه",
              "id": "versionCodeB",
              "field": "versionCode",
              "query": "gt",
              "type": "numberInteger"
            },
            {
              "title": "کوچکتر از کد نسخه",
              "id": "versionCodeS",
              "field": "versionCode",
              "query": "lt",
              "type": "numberInteger"
            }
          ]}
          filterValues={this.state.filters}
        />

        <div className="fragment text-center">

          <div className="list text-center">
            {this.state.list.length !== 0 && (
              <div>
                {this.state.list.map((item) => (
                  <Adapter
                    history={this.props.history}
                    key={item.id}
                    item={item}
                    form={this.state.form}
                    categoryPictureUrl={this.getQueryString("cp", undefined)}
                    categoryTitle={this.getQueryString("t", undefined)}
                  />
                ))}
              </div>
            )}

            {this.state.list.length !== 0 && this.state.endOfList === false && (
              <div
                style={{ paddingBottom: 6 , fontSize: 15, padding: 10}}
                onClick={this.onMoreClick}
                className="btn btn-outline-success mt-2 mb-4 col-11 col-sm-11 col-md-11 col-lg-11 col-xl-11"
              >
                {see_more}
              </div>
            )}

            {this.state.loading === true &&
              this.state.page === 0 &&
              this.state.list.length === 0 && <Loading />}

            {this.state.loading !== true &&
              this.state.page === 0 &&
              this.state.list.length === 0 && <NoItemFound/>}
          </div>

        </div>
      </div>

    );
  }

  onMoreClick = () => {
    if (this.state.loading === false) {
      this.callListApi(this.state.page + 1);
      this.setState({ loading: true, page: this.state.page + 1 });
    }
  };

  onFilterChanged = (filters) => {
    this.setState({
      filters: filters
    })
    setTimeout(function () {
      if (filters === this.state.filters) {
        this.setState({
          list: []
        })
        this.getFirstPage()
      }
    }.bind(this), 300)
  }

  onSortTypeChanged = (sortType) => {
    this.setState({
      sortType: sortType
    })
    setTimeout(function () {
      if (sortType === this.state.sortType) {
        this.setState({
          list: []
        })
        this.getFirstPage()
      }
    }.bind(this), 300)
  }

  onSortByChanged = (sortBy) => {
    this.setState({
      sortBy: sortBy
    })
    setTimeout(function () {
      if (sortBy === this.state.sortBy) {
        this.setState({
          list: []
        })
        this.getFirstPage()
      }
    }.bind(this), 300)
  }

  onSearchKeywordChanged = (keyword) => {
    this.setState({
      isSearchTyping: true,
      keyword: keyword
    })
    setTimeout(function () {
      if (keyword === this.state.keyword) {
        this.setState({
          list: []
        })
        this.getFirstPage()
      }
    }.bind(this), 1000)
  }

  getFirstPage() {
    window.scrollTo(0, 0);
    const page = parseInt(this.getQueryString("p", 0));
    this.callListApi(page);
    this.setState({ page });
  }

  /****
  ** NETWORK
  *****/

  callListApi(page) {
    var categoryId = this.getQueryString("ci", "")
    var filters = Object.assign([], this.state.filters);
    filters.push({
      "field": "categoryId",
      "query": "is",
      "value": categoryId
    },)
    this.setState({loading: true})
    releaseList( this.state.pageSize, page, this.state.sortBy, this.state.sortType, this.state.keyword, filters, this.handleListApiSuccess);
  }

  handleListApiSuccess = (data) => {
    this.setState({loading: false})
    const ended = data.list.length !== this.state.pageSize;
    var newArray = [];
    newArray.push.apply(newArray, this.state.list);
    newArray.push.apply(newArray, data.list);
    this.setState({ list: newArray, count: data.count, loading: false, endOfList: ended });
  };

  getQueryString(tag, defaultValue) {
    const query = new URLSearchParams(this.props.location.search);
    let value = query.get(tag);
    if (value === null) {
      value = defaultValue;
    }
    return value;
  }

}

//// REDUX STUFF
function mapStateToProps(state) {
  return {
    login: state.login,
    profile: state.profile,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ setSideMenuSelectedItem: setSideMenuSelectedItem, setToolbarTitle: setToolbarTitle }, dispatch);
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(Releases);
